import './WhyStandOut.css';

// SVG icons (lucide-style) matching the approved design
const IconBulb = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18h6" /><path d="M10 22h4" />
    <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.4 1 2.3h6c0-.9.4-1.8 1-2.3A7 7 0 0 0 12 2z" />
  </svg>
);
const IconShield = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const IconHeart = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z" />
    <path d="M12 5.5 9.5 9l3 2.5-2 3" />
  </svg>
);
const IconAward = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6" />
    <path d="M15.5 13 17 22l-5-3-5 3 1.5-9" />
  </svg>
);
const IconTarget = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);
const IconEye = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
);

const points = [
  { Icon: IconBulb, title: 'Innovation First', desc: 'We stay ahead of industry trends, integrating the latest technologies into every project we deliver.', delay: 'd1' },
  { Icon: IconShield, title: 'Transparent Process', desc: 'Clear communication, honest timelines, and no hidden costs — you always know exactly where your project stands.', delay: 'd2' },
  { Icon: IconHeart, title: 'Client-Centric', desc: 'Your goals are our goals. We tailor every solution to fit your unique business needs and growth objectives.', delay: 'd3' },
  { Icon: IconAward, title: 'Quality Assured', desc: 'Rigorous testing, clean code, and polished design ensure every deliverable meets the highest standards.', delay: 'd4' },
  { Icon: IconTarget, title: 'ROI Focused', desc: 'Every strategy we implement is designed to generate measurable returns on your investment.', delay: 'd5' },
  { Icon: IconEye, title: 'Long-Term Vision', desc: 'We build solutions that scale with your business, ensuring your digital assets grow alongside your ambitions.', delay: 'd6' },
];

export default function WhyStandOut() {
  return (
    <section id="why-stand-out" className="wso-section">
      <div className="wso-header reveal">
        <span className="section-label">Our Edge</span>
        <h2 className="section-title">Why Aerial Root <em>Stands Out</em></h2>
        <p className="section-sub">We don't just deliver services — we build partnerships that drive long-term success.</p>
      </div>
      <div className="wso-grid">
        {points.map(p => (
          <div key={p.title} className={`wso-item reveal ${p.delay}`}>
            <span className="wso-icon"><p.Icon /></span>
            <div>
              <h4>{p.title}</h4>
              <p>{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
